import type { FC } from 'react';
import { cx } from '@linaria/atomic';
import { FieldDescriptor, FieldDescriptorProps } from '../../atoms/field-descriptor.component';
import { CommonFieldAtomProps } from '../../atoms/types';
import { HelperTextStyles } from './helper-text.styles';

type CommonProps = Pick<CommonFieldAtomProps, 'disabled' | 'hasError'> & FieldDescriptorProps;

interface HelperTextProps extends CommonProps {
  disabled?: boolean;
  hasError?: boolean;
}

export const HelperText: FC<React.PropsWithChildren<HelperTextProps>> = ({
  children,
  className,
  disabled,
  hasError,
  ...rest
}) => {
  const helperTextClassName = HelperTextStyles.helperText({ disabled, hasError });

  return (
    <FieldDescriptor className={cx(helperTextClassName, className)} {...rest}>
      {children}
    </FieldDescriptor>
  );
};
